exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-styles[data-v-7ff3759e]{margin-bottom:3px!important;position:absolute;width:16px!important;height:16px;left:calc(50% - 8px);top:8px}", ""]);

// exports
